<template>
  <div class="validate-passwd-card">
    <h4 class="title">{{$t('share.title')}}</h4>
    <div class="password-inputer" :class="pwdStatus">
      <div class="input-wrap">
        <span class="icon-wrap">
          <font-icon id="key"></font-icon>
        </span>
        <input type="password" v-model="password" @click="clearError" :placeholder="$t('share.placeholder')" />
      </div>
      <div class="btn" @click="checkPwd">{{ $t('confirm') }}</div>
    </div>
    <div class="password-error-text" v-if="pwdStatus === 'error'">{{ $t('share.errorTip') }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      password: '',
      pwdStatus: 'success',
    }
  },
  props: {
    lang: {
      type: String,
      default: 'en-US'
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {},
  methods: {
    goDetailPage(res) {
      this.$emit('validated', res)
    },
    clearError() {
      this.pwdStatus = 'success'
    },
    checkPwd() {
      this.$axios({
          url: '/api/v1/client/estate/link/validatePwd',
          method: 'post',
          data: {
            password: this.password,
            agentName: this.$route.params.agent,
            type: this.type,
            suffix: this.$route.params.suffix,
          },
        })
        .then(res => {
          if (res.ok) {
            this.goDetailPage(res)
          } else {
            this.pwdStatus = 'error'
          }
        })
        .catch(err => {
          const code = err.response.status
          if (code === 401) {
            this.pwdStatus = 'error'
          }
        })
    },

  }
}

</script>
<style lang="scss" scoped>
.validate-passwd-card {
  width: 100%;
  margin: 20px 0;
  box-sizing: border-box;
  padding: 14px 20px;
  border-radius: 0 0 8px 8px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

}

.title {
  width: 100%;
  text-align: center;
}

.buttons {
  margin-top: 14px;

  .btn-main {
    padding: 8px 26px;
    color: #fff;
    border: none;
    background-color: #99d20d;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    outline: none;
  }
}

.password {
  position: relative;
  margin-top: 22px;
  margin-left: 42px;
}

.password-inputer {
  padding-bottom: 30px;

  .input-wrap {
    position: relative;
    display: inline-block;
    vertical-align: top;
    border: 1px solid #99d20d;
    width: 383px;
    padding: 14px 0 14px 50px;
    box-sizing: border-box;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border-right: none;

    .icon-wrap {
      display: inline-block;
      position: absolute;
      left: 21px;
    }

    input {
      // border: 1px solid #ddd;
      border: none;
      font-size: 14px;
      width: 326px;
      outline: none;
    }
  }

  .btn {
    display: inline-block;
    vertical-align: top;
    height: 48px;
    width: 93px;
    line-height: 48px;
    border: 1px solid #99d20d;
    box-sizing: border-box;
    text-align: center;
    color: #fff;
    background-color: #99d20d;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    cursor: pointer;
    border-left: none;
  }
}

.password-inputer.error {

  .input-wrap,
  .btn {
    border: 1px solid #ec6020;
  }

  .input-wrap {
    border-right: none;
  }

  .btn {
    border-left: none;
  }
}

.password-error-text {
  position: absolute;
  bottom: 10px;
  color: #ec6020;
  font-size: 14px;
}

</style>
